<template>
    <div class="panel fx-g1">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" clearable placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="分类">
                    <el-select v-model="form.categoryId" clearable placeholder="分类">
                        <el-option
                            v-for="item in trainCategorys"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                    <!-- <el-form-item label="标签">
                    <el-select v-model="form.tagId" clearable placeholder="标签">
                        <el-option
                            v-for="item in trainTags"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->
            </el-form>
            <el-button type="primary" @click="chooseQuestion()" v-if="(this.attr.item.type == 1 || (this.attr.item.type == 2 && this.attr.item.questionCount == 0)) && this.attr.item.institutionId != 1">选择训练题目</el-button>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%;overflow: auto"
                @selection-change="handleChoose"
            >
                <!-- <el-table-column
                    type="selection"
                    width="55">
                </el-table-column> -->
                <el-table-column
                    min-width="180"
                    prop="questionFormHtml"
                    label="题目" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="categoryName"
                    label="分类" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="optName"
                    label="语言类型" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="tagName"
                    label="标签" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="typeName"
                    label="类型" >
                </el-table-column>
                    <el-table-column
                    min-width="180"
                    prop="answer"
                    label="答案" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="difficulty"
                    label="难度" >
                </el-table-column>
                    <el-table-column
                label="操作"
                min-width="180"
            >
                <template slot-scope="scope" v-if="scope.row.institutionId != 1">
                    <el-popconfirm @onConfirm="remove(scope.row)"
                                    title="确认移除该题目吗？"
                    >
                        <el-link type="danger" slot="reference"
                                    :underline="false" ><i class="iconfont icon-shanchu"></i><b>移除</b></el-link>
                    </el-popconfirm>
                </template>
            </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <ChooseQuestionDrawer :item="chooseItem" v-if="showChoose" @close="showChoose = false" @submit="loadData"></ChooseQuestionDrawer>
    </div>
</template>

<style scoped>
.no_set {
    width: 55px;
    text-align: center;
}
.task_info{
    height: 40px;
    font-size: 12px;
    border-top: 1px solid var(--border);
}
.task_info:first-child{
    border-top: none;
}
.task_info .el-link {
    color: #f29100;
}
.lesson_info i.iconfont,.task_info i.iconfont {
    vertical-align: text-top;
}
.task_info > span {
    margin-right: 30px;
}
</style>


<script>
   import ChooseQuestionDrawer from "./ChooseQuestionDrawer";
    export default {
        props: [
            "attr"
        ],
        components: {
            ChooseQuestionDrawer,
        },
        data() {
            return {
                show: false,
                needRefreshParent: false,
                showChoose:false,
                form: {
                    keywords: "",
                    enable: true,
                    // ...this.item
                },
                tableData: [],
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                choosedList: [],
                trainCategorys:[],
                trainTags:[],
            }

        },

        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true

            }
        },
        methods: {
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {

                    this.$emit("close");
                }
            },
            handleChoose(val) {
                this.choosedList = val;
            },
            chooseQuestion() {
                this.chooseItem = {...this.attr.item};
                this.showChoose = true;
            },
            loadData() {
                let url = this.attr.checkType == true ? "/trainQuestion/getTrainQuestionByAddPlatform" : "/trainQuestion/getTrainQuestionByAdd";
                this.$ajaxPost(url, {
                    form: this.form,
                    trainModuleId: this.attr.item.id,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    this.showChoose = false;
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            loadTrainCategory() {
                let url = this.attr.checkType == true ? "/trainCategory/listOption/1" : "/trainCategory/listOptionBySchool/1";
                this.$ajaxGet(url, (data) => {
                     this.trainCategorys = data.result;
                })
            },
            loadTrainTag() {
                let url = this.attr.checkType == true ? "/trainCategory/listOption/2" : "/trainCategory/listOptionBySchool/2";
                this.$ajaxGet(url, (data) => {
                     this.trainTags = data.result;
                })
            },
            remove(item){
                this.$ajaxGet("/trainQuestionLink/del/"+ this.attr.item.id +"-"+item.id, (data) => {
                    this.loadData();
                    this.$showSuccess("操作成功", 600, ()=>{
                        this.needRefreshParent = true;
                        this.$emit("submit");
                    });
                      
                })
            },

        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadData();
            this.loadTrainCategory();
            //this.loadTrainTag();
        }


    }
</script>
